module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-center_wb"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "WBad/WBlogo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "end-title_wb"
  }, [_vm._v("Sign up for our"), _c('br'), _vm._v("newsletter to discover"), _c('br'), _vm._v("more ebooks worth"), _c('br'), _vm._v("reading.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center_wb1"
  }, [_c('a', {
    attrs: {
      "href": "http://worthbooks.com/subscribe/?utm_medium=frontad&utm_source=worthbooks&utm_campaign=ISBN",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "WBad/WBsignup.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ce78bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WBad/WBNewsletter.vue
// module id = 60
// module chunks = 0